import { render, staticRenderFns } from "./AddFieldButton.vue?vue&type=template&id=dd8567e4&"
import script from "./AddFieldButton.vue?vue&type=script&lang=js&"
export * from "./AddFieldButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports